module.exports = __webpack_public_path__ + "static/img/200224.d912cb77.png";